import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function FindTicket() {
  const [ticketId, setTicketId] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (ticketId) {
      navigate(`/edit/${ticketId}`);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center h-full">
      <div className="w-full max-w-md p-8 space-y-6 bg-white rounded-lg shadow-md">
        <h1 className="text-2xl font-bold text-center">Find Ticket</h1>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="ticketId" className="block text-sm font-medium text-gray-700">
              Ticket ID
            </label>
            <input
              id="ticketId"
              name="ticketId"
              type="text"
              required
              className="w-full px-3 py-2 mt-1 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              value={ticketId}
              onChange={(e) => setTicketId(e.target.value)}
              placeholder="Enter Ticket ID"
            />
          </div>
          <button
            type="submit"
            className="w-full px-4 py-2 text-white bg-indigo-600 rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Find Ticket
          </button>
        </form>
      </div>
    </div>
  );
}

export default FindTicket;
